<template>
  <header class="header" v-if="layoutState.isHeader">
    <div class="header__inner" v-if="layoutState.isMain">
      <h1 class="logo" v-if="userData.userType === 1"></h1>
      <h1 class="text_title" v-else>{{ userData.companyName }} • {{ userData.contactName }}</h1>
      <div class="header__btns home">
        <button class="header__logout underline" @click="$router.push('/elect/select')" v-if="userData.userType === 2">회원사 선택</button>
        <button class="header__btns alarm" @click="$router.push('/mypage/pushLog')"></button>
        <div class="badge" style="margin-left: -10px;" v-show="pushUnreadCount > 0">{{ pushUnreadCount }}</div>
      </div>
    </div>
    <div class="header__inner type_02" v-if="!layoutState.isMain && !layoutState.isMypage">
      <div class="header__btns">
        <button class="header__btns" v-if="layoutState.headerIconType === $ConstCode.HEADER_ICON_TYPE.LOGOUT"></button>
        <button class="header__btns prev" v-else @click="fnBack()"></button>
      </div>
      <h1 class="header__ttl">{{ titleName === '' ? layoutState.titleName : titleName }}</h1>
      <div class="header__logout underline" v-if="layoutState.headerIconType === $ConstCode.HEADER_ICON_TYPE.LOGOUT" @click="fnLogout()">로그아웃</div>
      <div class="header__btns" v-else>
        <button class="header__btns map" v-show="layoutState.headerIconType === $ConstCode.HEADER_ICON_TYPE.MAP" @click="moveStationMap()"></button>
        <button class="header__btns setting" v-show="layoutState.headerIconType === $ConstCode.HEADER_ICON_TYPE.SETTING"
                @click="$EventBus.$emit('showOptions')"></button>
      </div>
    </div>
    <div class="header__inner type_03" v-if="!layoutState.isMain && layoutState.isMypage">
      <p>안녕하세요, <span class="medium">{{ userData.userType === 1 ? userData.companyName : userData.contactName }}</span>님</p>
    </div>
  </header>
</template>
<script>
import router from "@/router";

export default {
  name: 'HeaderBar',
  props: {
    userDataState: {
      type: [Object],
      description: '유저 정보 상태'
    },
    layoutState: {
      type: [Object],
      description: 'layout(헤더, 푸터 등) 상태'
    }
  },
  data: function () {
    return {
      isMenu: false,
      titleName: '',
      pushUnreadCount: 0
    }
  },
  created: function () {
    this.$EventBus.$on('HeaderBar.setTitleName', this.onReceive);
    this.$EventBus.$on('HeaderBar.getUserPushLogUnreadCount', this.getUserPushLogUnreadCount)
  },
  computed: {
    isHideHeader() {
      return this.$store.getters['layout/getIsHideHeader']
    },
    userData() {
      return this.$store.getters['account/getUserData']
    },
    isSideBar: function () {
      return this.$store.getters['layout/getIsSideBar']
    },
    isScroll: function () {
      return this.$store.getters['layout/getIsScroll']
    }
  },
  methods: {
    fnBack: function () {
      const currentPath = this.$router.history.current.path
      switch (currentPath) {
        case '/account/joinComplete':
          router.replace('/account/login')
          return false
        case '/elect/select':
          console.log(this.userData)
          router.replace('/account/login')
          return false
      }


      let query = this.$route.query
      if (!this.$Util.isEmpty(query.rUrl)) {
        this.$router.replace({path: query.rUrl})
        return
      } else if (query.isPush === 1) {
        this.$router.replace({path: '/'})
        return
      }

      this.$router.go(-1)
    },
    fnShowDrawer: function () {
      this.$store.commit('layout/setIsSideBar', {isSideBar: true})
    },
    fnLogout: function () {
      const _this = this
      this.$Util.modalConfirm(this.$ConstCode.CONFIRM_TYPE.LOGOUT, {}, async function () {
        const res = await _this.$AccountSvc.logout()
        const code = res.code
        const message = res.message
        const entity = res.entity

        console.log('code: %d\nmessage: %s\nentity: %o\nstringify: \n%s', code, message, entity, JSON.stringify(entity))
        if (code === 1) {
          setTimeout(function () {
            _this.$router.replace({path: '/account/login'})
          }, 200)
        } else {
          setTimeout(function () {
            _this.$Util.modalAlert({message: message})
          }, 200)
        }
      })
    },
    moveStationMap: function () {
      this.$router.push({
        path: '/comm/stationMap',
        query: {
          schedulePassengerNo: this.$route.query.schedulePassengerNo
        }
      })
    },
    onReceive: function (text) {
      console.log('onReceive')
      this.titleName = text
    },
    getUserPushLogUnreadCount: async function () {
      const res = await this.$CommonSvc.getUserPushLogUnreadCount({userNo: this.userDataState.userNo})
      const code = res.code
      const message = res.message
      const entity = res.entity
      if (code === 1) {
        this.pushUnreadCount = entity
      }
    }
  }
}
</script>
<style lang="scss">
.fade-enter-active,
.fade-leave-active {
  transition: opacity .5s
}

.fade-enter,
.fade-leave-to {
  opacity: 0
}
</style>
